<template>
  <div class="content">
    <div class="content-main">
      <p class="content-title">首页图标入口</p>
      <div class="content-input">
        <div class="content-input-item">
          <label>状态：</label>
          <el-select v-model="state" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in stateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>展示平台：</label>
          <el-select v-model="platform" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in platformArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <ElButtons type="primary" icon="search" v-loading="searchLoading" :disable="searchLoading" @click="getPage(true)"> 查询 </ElButtons>
          <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
        </div>
      </div>
    </div>
    <div class="content-main">
      <div class="content-button">
        <div>
          <el-button type="primary" @click="editBannerDialog(-1)">创建</el-button>
        </div>
        <BtnGroup :tableRef="$refs.multipleTableRef" :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
      </div>
      <div class="content-table">
        <el-table
            ref="multipleTableRef"
            :data="pageDataList"
            style="width: 100%"
            v-loading="listLoading"
            @cell-click="toggleSelection"
            border
        >
          <el-table-column property="createTime" label="创建时间" v-if="checkColList.indexOf('创建时间') > -1" ></el-table-column>
          <el-table-column property="" label="图片" v-if="checkColList.indexOf('图片') > -1">
            <template #default="scope">
              <el-image style="height: 80px; min-width: 80px;" :src="scope.row.picture"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
            </template>
          </el-table-column>
          <el-table-column property="name" label="名称" v-if="checkColList.indexOf('名称') > -1">
            <template #default="scope">
              <p>{{scope.row.name}}</p>
              <p style="color: #da0e32">{{scope.row.remark}}</p>
            </template>
          </el-table-column>
          <el-table-column property="" label="调整类型" v-if="checkColList.indexOf('调整类型') > -1">
            <template #default="scope">
              <p>{{scope.row.urlType == 1 ? '跳转内部浏览器' : scope.row.urlType == 2 ? '跳转到外部浏览器' : scope.row.urlType == 3 ? '跳转到原生页面' : ''}}</p>
            </template>
          </el-table-column>
<!--          <el-table-column property="" label="展示平台" v-if="checkColList.indexOf('展示平台') > -1">-->
<!--            <template #default="scope">-->
<!--              <p>{{scope.row.showPlatform == -1 ? '客户端' : scope.row.showPlatform == 1 ? 'Android' : scope.row.showPlatform == 2 ? 'IOS' : scope.row.showPlatform == 3 ? 'Web' : ''}}</p>-->
<!--            </template>-->
<!--          </el-table-column>-->
          <el-table-column property="jumpUrl" label="跳转地址" v-if="checkColList.indexOf('跳转地址') > -1">
            <template #default="scope">
              <span>{{scope.row.urlType == 3 && scope.row.jumpUrl ? appUrlArray[scope.row.jumpUrl - 1].label : scope.row.jumpUrl}}</span>
            </template>
          </el-table-column>
          <el-table-column property="showOrder" label="排序" v-if="checkColList.indexOf('排序') > -1"></el-table-column>
          <el-table-column property="" label="状态" v-if="checkColList.indexOf('状态') > -1">
            <template #default="scope">
              <p>{{scope.row.state == 1 ? '待展示' : scope.row.state == 2 ? '展示中' : scope.row.state == 3 ? '已下架' : ''}}</p>
            </template>
          </el-table-column>
          <el-table-column property="" label="操作" v-if="checkColList.indexOf('操作') > -1" width="320">
            <template #default="scope">
              <el-space wrap>
                <el-button size="small" @click="editBannerDialog(scope.$index,scope.row)" type="primary">编辑</el-button>
                <el-button size="small" v-loading="scope.row['updateLoading']" type="success" v-if="scope.row.state == 1 || scope.row.state == 3" @click="updateState(scope.$index, scope.row, 2)">上架</el-button>
                <el-button size="small" v-loading="scope.row['updateLoading']" type="danger" v-if="scope.row.state == 2" @click="updateState(scope.$index, scope.row, 3)">下架</el-button>
                <el-button size="small" v-loading="scope.row['sendLoading']"  type="primary"  @click="sendNotice(scope.$index, scope.row)">发送通知</el-button>
                <el-button size="small" v-loading="scope.row['newPeopleLoading']" type="success" v-if="scope.row.sendNewcomerPrompt == 0" @click="newPeople(scope.$index, scope.row, 1)">新人提示</el-button>
                <el-button size="small" v-loading="scope.row['newPeopleLoading']" type="warning" v-if="scope.row.sendNewcomerPrompt == 1" @click="newPeople(scope.$index, scope.row, 0)">取消新人提示</el-button>
              </el-space>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import BtnGroup from '../../components/BtnGroup'
import { getHomeIconPageList, updateHomeIconState, updateHomeTopSendNotification, updateHomeTopSendNewcomerPrompt } from '../../api/url'
import {getFormData, postFormData} from '../../api/api'
import Dialog from "@/assets/js/dialog";
import iconDialog from "@/views/banner/components/iconDialog";
import ImgUpload from "./components/ImgUpload";

export default {
  name: "BannerIcon",
  components: { BtnGroup },
  data() {
    return {

      stateArray: [
        {label: '不限', value: -1},
        {label: '待展示', value: 1},
        {label: '展示中', value: 2},
        {label: '已下架', value: 3},
      ],
      state: 2,

      //平台
      platformArray: [
        {label: "不限",value: -1},
        {label: "Android",value: 1},
        {label: "鸿蒙",value: 4},
        {label: "iOS",value: 2}
      ],
      platform: -1,

      //原生页面
      appUrlArray: [
        {label: "三行情书",value: '1'},
        {label: "发现页",value: '2'},
        {label: "小纸条",value: '3'},
        {label: "红娘牵线服务",value: '4'},
        {label: "星级特权",value: '5'},
        {label: "最近访问",value: '6'},
        {label: "邀请认证",value: '7'},
        {label: "微信下载记录",value: '8'},
        {label: "心动列表",value: '9'},
        {label: "对你感兴趣的人",value: '10'},
        {label: "微信审核",value: '11'},
        {label: "视频认证",value: '12'},
        {label: "身份认证",value: '13'},
        {label: "职业认证",value: '14'},
        {label: "学历认证",value: '15'},
        {label: "车辆认证",value: '16'},
        {label: "房屋认证",value: '17'},
        {label: "信息置顶",value: '18'},
        {label: "微信设置 ",value: '19'},
        {label: "编辑沟通用语",value: '20'},
        {label: "新消息通知",value: '21'},
        {label: "意见反馈",value: '22'},
        {label: "黑名单",value: '23'},
        {label: "关于我们",value: '24'},
        {label: "达人排行榜",value: '25'},
      ],
      appUrl: '1',

      //刷新组
      colList: ['创建时间', '图片', '名称', '调整类型', '跳转地址', '排序', '状态','操作'],
      checkColList: [],

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,

      searchLoading: false,
      listLoading: false,

    }
  },
  methods: {
    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },
    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },
    // 重置参数
    refreshParam() {
      this.state = 2;
      this.platform = -1;
      this.getPage(true);
    },
    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['state'] = this.state;
      param['showPlatform'] = this.platform;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getHomeIconPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch(() => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    editBannerDialog(idx, row) {
      let _title = '';
      let iconForm = {}
      if (idx > -1) {
        _title = '编辑图标'
        iconForm = Object.assign({}, row);
      }else {
        _title = '创建图标'
      }
      Dialog.open({
        title: _title,
        component: iconDialog,
        data: {
          iconForm: iconForm,
          ids: idx,
          width: '1040px'
        },
        confirm: (result) => {
            this.getPage()
        }
      })
    },

    // toggleSelection(row, column, cell, event) {
    //
    //   if(column.label == 'banner图片') {
    //     Dialog.open({
    //       title: '上传banner图片',
    //       component: ImgUpload,
    //       data: {
    //         id: row.id,
    //         src: row.picture,
    //         width: '400px'
    //       },
    //       close: () => {
    //         this.getPage()
    //       }
    //     })
    //   }
    // },

    updateState(idx, row, state) {
      this.pageDataList[idx]['updateLoading'] = true;
      let param = {};
      param['id'] = row.id;
      param['state'] = state;
      postFormData(updateHomeIconState, param).then((data)=>{
        let {code, msg} = data;
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'success'
          })
          this.getPage()
        }else {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.pageDataList[idx]['updateLoading'] = false;
      }).catch(()=> {
        this.pageDataList[idx]['updateLoading'] = false;
      })
    },

    // 发送通知
    sendNotice(idx, row) {
      this.$confirm('确定发送红点通知？').then(() => {
        this.pageDataList[idx]['sendLoading'] = true;
        let param = {};
        param['id'] = row['id'];
        postFormData(updateHomeTopSendNotification, param).then((data) => {
          let {code, msg} = data;
          if(code == 200){
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            });
          } else {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            });
          }
          this.pageDataList[idx]['sendLoading'] = false;
        })
            .catch(() => {
              this.pageDataList[idx]['sendLoading'] = false;
            })
      })
          .catch(() => {})
    },


    // 发送新人提示
    newPeople(idx, row, state) {
      this.$confirm('确定' + (state == 1 ? '发送' : '取消发送') + '新人提示？').then(() => {
        this.pageDataList[idx]['newPeopleLoading'] = true;
        let param = {};
        param['id'] = row['id'];
        param['sendNewcomerPrompt'] = state;
        postFormData(updateHomeTopSendNewcomerPrompt, param).then((data) => {
          let {code, msg} = data;
          if(code == 200){
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            });
            row['sendNewcomerPrompt'] = state;
          }else {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            });
          }
          this.pageDataList[idx]['newPeopleLoading'] = false;
        })
            .catch(() => {
              this.pageDataList[idx]['newPeopleLoading'] = false;
            })
      })
          .catch(() => {})
    }


  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
  }
}
</script>

<style scoped>

</style>
